import React from 'react';
import { uuid } from 'uuidv4'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import getTime from "../../helpers/zoomHelpers/getTime";
import createAvailability from "../../helpers/zoomHelpers/createAvailability";
import formatDateTime from "../../helpers/zoomHelpers/formatDateTime";
import formatExpertInvite from "../../helpers/expertHelpers";
import { addHoursAndMinutesInMs } from "../../helpers/zoomHelpers";
import AnonymizeToggle from "../AnonymizeToggle"; // API

import { getEmailTemplateByGroup } from "../../api";

const RenderExpertAction = ({
  checkbox
}) => {
  const {
    state,
    dispatch
  } = useStore();
  const {
    expertinviteEdited,
    currentPath,
    schedule,
    quickInviteExpert,
    sendZoomUpdate,
    availabilityStore_imp,
    meetingType,
    expertInvited,
    selectedLanguage,
    firstMatch,
    dayToRender,
    duration,
    zoomNum,
    employeeSubmitted,
    expertCountry,
    expertTimezoneName,
    timezoneTranslated,
    languageUpdated,
    templateId,
    previouslySendLanguage,
    expertDayOffset,
    showExpertCountry,
    expertMessage,
    mcKinseyMessage,
    mcKinseyTemplates
  } = state;

  const goToInvite = () => {
    dispatch({
      type: 'UPDATE',
      payload: {
        lastPath: currentPath,
        currentPath: 'sendInviteExpert'
      }
    });
  };

  const setupSchedule = () => {
    const selectedStartDate = currentPath === 'overview' ? new Date(parseInt(firstMatch.toString())).setHours(0, 0, 0, 0) : new Date(parseInt(dayToRender.format('x'))).setHours(0, 0, 0, 0);
    const timeObj = currentPath === 'overview' ? getTime(schedule.timeslots[0].time.start, duration) : getTime();
    const {
      hourStart,
      minutesStart,
      hourEnd,
      minutesEnd
    } = timeObj;

    if (currentPath === 'calendarview') {
      const start = addHoursAndMinutesInMs(selectedStartDate, hourStart, minutesStart);
      const end = addHoursAndMinutesInMs(selectedStartDate, hourEnd, minutesEnd);
      const newTimeslot = {
        duration: duration,
        id: uuid(),
        time: {
          start,
          end
        },
        drafts: []
      };

      if (!!schedule.timeslots.length && schedule.timeslots[0].time.start !== newTimeslot.time.start || !schedule.timeslots.length) {
        dispatch({
          type: 'SETSCHEDULE',
          payload: {
            schedule: { ...schedule,
              timeslots: [newTimeslot],
              availabilities: [...schedule.availabilities, ...createAvailability(newTimeslot, duration)]
            }
          }
        });
      }
    }

    goToInvite();
  };

  const onClickAction = async () => {
    if (meetingType !== 'Zoom' && expertMessage.includes('MEETINGID')) {
      if (meetingType === 'mcKinsey') {
        dispatch({
          type: 'UPDATE',
          payload: {
            expertMessageUpdated: expertInvited ? expertMessage : mcKinseyMessage,
            templates: mcKinseyTemplates
          }
        });
        return;
      }

      const responseTemplates = await getEmailTemplateByGroup('schedule_invite_no_honorarium_free');
      const newTemplate = responseTemplates.filter(d => d.name.toLowerCase().includes(selectedLanguage))[0].content;
      dispatch({
        type: 'UPDATE',
        payload: {
          expertMessage: formatExpertInvite(newTemplate, schedule, availabilityStore_imp, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry)
        }
      });
    }

    if (!schedule.timeslots.length) {
      setupSchedule();
    } else {
      goToInvite();
    }

    dispatch({
      type: 'UPDATE',
      payload: {
        lastPath: currentPath
      }
    });
  };

  const {
    persistedScheduleInfo
  } = availabilityStore_imp;
  const anonymizeStateKey = 'anonymizeExpert';

  if (persistedScheduleInfo && persistedScheduleInfo.outlookExpertEvent) {
    const {
      outlookExpertEventCreator,
      expertInvitationSentDate,
      outlookExpertEvent
    } = persistedScheduleInfo;
    const eventCreator = outlookExpertEventCreator && outlookExpertEventCreator.fullName;
    const eventCreationDate = expertInvitationSentDate || outlookExpertEvent.lastModifiedDateTime;
    const eventMessage = eventCreator ? `${eventCreator} has invited expert on ${formatDateTime(eventCreationDate)}` : `Expert has been invited on ${formatDateTime(eventCreationDate)}`;
    return /*#__PURE__*/React.createElement("div", {
      className: "request-schedule__invite-item_NEW"
    }, eventMessage, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex'
      }
    }, meetingType === 'Zoom' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnonymizeToggle, {
      stateKey: anonymizeStateKey
    }), /*#__PURE__*/React.createElement("div", {
      className: "separator",
      style: {
        margin: '0 6px'
      }
    }, "|")), /*#__PURE__*/React.createElement("div", {
      className: "request-schedule__invite-action_NEW",
      onClick: () => {
        setupSchedule();
      }
    }, "Modify")));
  }

  if (meetingType === 'None' || meetingType === 'mcKinsey') {
    return /*#__PURE__*/React.createElement("div", {
      className: "request-schedule__invite-item_NEW"
    }, /*#__PURE__*/React.createElement("div", {
      id: "editZoomInfo"
    }, "Expert calendar invitation has not been sent"), /*#__PURE__*/React.createElement("div", {
      className: "request-schedule__invite-action_NEW"
    }, /*#__PURE__*/React.createElement("span", {
      onClick: onClickAction
    }, (() => {
      if (!schedule.timeslots.length) return 'Select timeslot and send invite';
      if (expertInvited) return 'Modify';
      if (expertinviteEdited !== 'expert') return 'Send invite';
      return 'Modify';
    })())));
  }

  return expertinviteEdited !== 'expert' ? /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-item_NEW"
  }, /*#__PURE__*/React.createElement("div", {
    id: "editZoomInfo"
  }, "Expert calendar invitation has not been sent"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, checkbox && /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: "Expert" // @ts-ignore
    ,
    value: quickInviteExpert,
    checked: quickInviteExpert,
    onChange: e => dispatch({
      type: 'UPDATE',
      payload: {
        quickInviteExpert: !quickInviteExpert
      }
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-action_NEW"
  }, sendZoomUpdate ? /*#__PURE__*/React.createElement("span", {
    onClick: goToInvite
  }, " Send invite") : /*#__PURE__*/React.createElement("span", null, " Expert")))) : /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-item_NEW"
  }, /*#__PURE__*/React.createElement("div", {
    id: "editZoomInfo"
  }, "Expert Invite Update (sent on confirm -", selectedLanguage, ")"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, meetingType === 'Zoom' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnonymizeToggle, {
    stateKey: anonymizeStateKey
  }), /*#__PURE__*/React.createElement("div", {
    className: "separator",
    style: {
      margin: '0 6px'
    }
  }, "|")), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-action_NEW",
    onClick: setupSchedule
  }, "Modify")));
};

export default RenderExpertAction;